module.exports = __webpack_public_path__ + "assets/img/33_845_big.0ccac916.jpg";